// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"821":"07448ffa","978":"3a1a5d2a"}[chunkId] + ".chunk.js";
};